import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  return <section id="home" className="relative h-screen w-full overflow-hidden" data-id="element-97">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0" style={{
      backgroundImage: "url('https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=1920&q=80')"
    }} data-id="element-98">
        <div className="absolute inset-0 bg-black/60 z-10" data-id="element-99" />
      </div>

      {/* Content */}
      <div className="relative z-20 h-full flex flex-col justify-center items-center text-center px-4 sm:px-6 lg:px-8" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto" data-id="element-101">
          <h2 className="text-brand-red font-display font-bold tracking-widest uppercase text-lg md:text-xl mb-4" data-id="element-102">
            Est. 2025 • Trans Nzoia, Kenya
          </h2>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-display font-bold text-white mb-6 leading-tight" data-id="element-103">
            BLAZING BARRY'S
            <br data-id="element-104" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-300" data-id="element-105">
              COFFEE
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 font-light max-w-2xl mx-auto mb-10" data-id="element-106">
            Specialty Kenyan Arabica from the fertile highlands of Mt. Elgon.
            Bold. Authentic. Youth-Led.
          </p>

          <motion.a href="#about" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-brand-red text-white font-display font-bold uppercase tracking-wider py-4 px-10 text-lg rounded-sm hover:bg-red-700 transition-colors shadow-lg" data-id="element-107">
            Discover Our Coffee
          </motion.a>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1,
        y: [0, 10, 0]
      }} transition={{
        delay: 1,
        duration: 2,
        repeat: Infinity
      }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white" data-id="element-108">
          <ChevronDown size={40} className="opacity-80" data-id="element-109" />
        </motion.div>
      </div>
    </section>;
}